import { motion } from "framer-motion";
import { Scale, Wrench, Sparkles, Stethoscope, Home, Building2, Car, Scissors, UtensilsCrossed, Dumbbell, Calculator, PawPrint, Shield, Building, MoreHorizontal } from "lucide-react";

const Industries = () => {
  const industries = [
    {
      icon: Scale,
      name: "Lawyers & Legal",
      description: "Personal injury, family law, criminal defense, and more.",
    },
    {
      icon: Wrench,
      name: "Plumbers & HVAC",
      description: "Emergency repairs, installations, and maintenance services.",
    },
    {
      icon: Sparkles,
      name: "Commercial Cleaners",
      description: "Office cleaning, janitorial, and facility maintenance.",
    },
    {
      icon: Stethoscope,
      name: "Dentists & Healthcare",
      description: "Dental practices, chiropractors, and medical clinics.",
    },
    {
      icon: Home,
      name: "Real Estate Agents",
      description: "Residential and commercial real estate services.",
    },
    {
      icon: Building2,
      name: "Home Services",
      description: "Electricians, roofers, landscapers, and contractors.",
    },
    {
      icon: Car,
      name: "Auto Services",
      description: "Mechanics, detailing, towing, and body shops.",
    },
    {
      icon: Scissors,
      name: "Salons & Spas",
      description: "Hair salons, barbershops, nail studios, and day spas.",
    },
    {
      icon: UtensilsCrossed,
      name: "Restaurants & Catering",
      description: "Local restaurants, food trucks, and catering services.",
    },
    {
      icon: Dumbbell,
      name: "Fitness & Wellness",
      description: "Gyms, personal trainers, yoga studios, and more.",
    },
    {
      icon: Calculator,
      name: "Accountants & CPAs",
      description: "Tax preparation, bookkeeping, and financial advisory.",
    },
    {
      icon: PawPrint,
      name: "Veterinarians",
      description: "Pet clinics, emergency care, and grooming services.",
    },
    {
      icon: Shield,
      name: "Insurance Agents",
      description: "Home, auto, life, and business insurance services.",
    },
    {
      icon: Building,
      name: "Property Managers",
      description: "Rental management, HOA services, and leasing.",
    },
    {
      icon: MoreHorizontal,
      name: "Others",
      description: "Any local service business looking for more leads.",
    },
  ];

  return (
    <section id="industries" className="py-12 md:py-16 relative">
      <div className="container mx-auto px-4 max-w-[1280px]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center space-y-4 mb-10"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold">
            Serving <span className="text-gradient">All Local Businesses</span> Across North America
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            From coast to coast across the <span className="text-foreground font-semibold">USA and Canada</span>, 
            we help every local business get found on AI. If people ask AI "who's the best [your service] near me?" — we make sure you show up first.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {industries.map((industry, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.03 }}
              className="group glass rounded-xl p-4 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/5 transition-all cursor-pointer text-center"
            >
              <div className="w-12 h-12 rounded-xl bg-accent/10 border border-accent/20 flex items-center justify-center mx-auto mb-3 group-hover:bg-accent/20 group-hover:border-accent/40 group-hover:scale-110 transition-all">
                <industry.icon className="h-6 w-6 text-accent" />
              </div>
              <h3 className="text-sm font-semibold mb-1 group-hover:text-accent transition-colors">
                {industry.name}
              </h3>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {industry.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center mt-8"
        >
          <p className="text-muted-foreground">
            Don't see your industry?{" "}
            <a href="#contact" className="text-primary hover:underline font-semibold">
              Let's talk
            </a>{" "}
            — if you serve local customers, we can help you dominate AI search.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Industries;
